export default __webpack_public_path__ + "static/mr-c9a9ef37738d292b7eabfab076da762c.svg";